import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import apiResponses from './permenantlySuspendController.json';

const queryPermenantlySuspendBill = (req, res, ctx) => {
  return res(
    ctx.json(mockResponse(apiResponses['permenantlySuspendController/queryPermenantlySuspendBill'].success.default))
  );
};

export const handlers = [
  rest.post(
    getApiEndpoint('permenantlySuspendController/queryPermenantlySuspendBill'),
    withScenario(withAuthCheck(queryPermenantlySuspendBill))
  ),
];
